<app-loading *ngIf="contentReady"></app-loading>

<div class="vcash-add-address-page" style="margin-bottom: 120px;" [class.margin-btm]="!isCreateOrder">

  <!-- TOP HEADER -->
  <section class="vcash-top" *ngIf="!isCreateOrder">
    <div class="vcash-appbar">
      <button class="appbar-btn" type="button" (click)="router.navigate(['/address'])">
        <img [src]="isAr ? '/assets/e-commerce/icons/60.webp' : '/assets/e-commerce/icons/61.webp'" alt="back" />
      </button>

      <h1 class="appbar-title">
        {{ isCreateOrder ? ('Add Address' | transloco) : ('myaddresses' | transloco) }}
      </h1>

      <div class="appbar-btn appbar-btn--ghost" routerLink="/notifications">
        <img src="/assets/e-commerce/icons/55.webp" alt="notifications" />
      </div>
    </div>
  </section>

  <!-- CONTENT -->
  <div class="vcash-content">

    <!-- SUMMARY -->
    <section class="address-summary-card" *ngIf="!isCreateOrder">
      <div class="address-summary-left">
        <span class="address-overline">{{ "Add Address" | transloco }}</span>
        <h2>{{ isCreateOrder ? ('Delivery' | transloco) : ('New Address' | transloco) }}</h2>
        <p>{{ "Add your address details and location"| transloco }}</p>
      </div>

      <div class="address-summary-icon">
        <img src="/assets/e-commerce/icons/54.webp" alt="address">
      </div>
    </section>

    <!-- FORM CARD -->
    <section class="form-card" [class.margin-top]="isCreateOrder">
      <form [formGroup]="addressForm" (ngSubmit)="addAddress()">

        <div class="form-grid">

          @if(!isCreateOrder){
          <div class="field full">
            <label>{{ "Address Title" | transloco }}</label>
            <input type="text" class="form-control" formControlName="address_title"
              placeholder="{{ 'Home / Work' | transloco }}">
          </div>
          }

          <div class="field">
            <label>{{ "Governorate" | transloco }}</label>
            <select class="form-control" formControlName="government_id" (change)="loadCities($event)" [ngClass]="{
                'is-invalid': addressForm.controls['government_id'].touched && addressForm.controls['government_id'].errors,
                'is-valid': addressForm.controls['government_id'].touched && !addressForm.controls['government_id'].errors
              }">
              <option value="">{{ "Select Governorate" | transloco }}</option>
              <option *ngFor="let gov of governorates" [value]="gov.id">
                {{ isAr ? gov.governorate_name_ar : gov.governorate_name_en }}
              </option>
            </select>
          </div>

          <div class="field">
            <label>{{ "area" | transloco }}</label>
            <select class="form-control" formControlName="city_id" [ngClass]="{
                'is-invalid': addressForm.controls['city_id'].touched && addressForm.controls['city_id'].errors,
                'is-valid': addressForm.controls['city_id'].touched && !addressForm.controls['city_id'].errors
              }">
              <option value="">{{ "Select area" | transloco }}</option>
              <option *ngFor="let city of cities" [value]="city.id">
                {{ isAr ? city.city_name_ar : city.city_name_en }}
              </option>
            </select>
          </div>

          <div class="field full">
            <label>{{ "address" | transloco }}</label>
            <input type="text" class="form-control" formControlName="address" [ngClass]="{
                'is-invalid': addressForm.controls['address'].touched && addressForm.controls['address'].errors,
                'is-valid': addressForm.controls['address'].touched && !addressForm.controls['address'].errors
              }" placeholder="{{ 'Full address' | transloco }}">
          </div>

          <div class="field full">
            <label>{{ "Google Maps Link" | transloco }}</label>
            <input type="text" class="form-control" formControlName="location_link"
              placeholder="{{ 'Send Current Locationholder' | transloco }}">
          </div>

          @if(!isCreateOrder){
          <div class="field full">
            <div class="map-wrap">
              <google-map height="400px" width="100%" [center]="center" [zoom]="12" [options]="mapOptions"
                (mapClick)="onMapClick($event)">
                <map-marker *ngIf="markerPosition" [position]="markerPosition" [options]="markerOptions"
                  (mapDragend)="onMarkerDragEnd($event)">
                </map-marker>
              </google-map>
            </div>
          </div>
          }

        </div>

        <div class="cart-summary">
          <button class="checkout-btn clear-cart" type="button" (click)="getCurrentLocation()">
            {{ "Send Current Location" | transloco }}
          </button>

          @if(!isCreateOrder){
          <button class="checkout-btn" type="submit" [disabled]="addressForm.invalid">
            {{ "Add Address" | transloco }}
          </button>
          }
        </div>

      </form>
    </section>

  </div>
</div>